import React, { useEffect, useState } from 'react';
import './CooperationConditionDocument.scss';
import logo from 'Assets/Images/growing-people-logo.svg';
import logo1 from 'Assets/Images/logo_1.svg';
import logo2 from 'Assets/Images/logo_2.svg';
import logo3 from 'Assets/Images/logo_3.svg';
import logo4 from 'Assets/Images/logo_4.svg';
import logo5 from 'Assets/Images/logo_5.svg';
import { useParams } from 'react-router-dom';
import { API_URL } from 'Store/Shared/Middleware/API/Constants';

const CooperationConditionDocument = () => {
    const params: any = useParams();
    const [data, setData] = useState<any>({});
    const [formatted, setFormatted] = useState<any>({});

    useEffect(() => {
        document.body.classList.add('document');

        const token: any = localStorage.getItem(window.btoa('accessToken'));
        const accessToken = window.atob(token);

        fetch(`${API_URL}/api/cooperation_condition/${params.id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        })
        .then(r => r.json())
        .then(({data}: any) => {
            console.log(data);
            setData(data);

            console.log(data.authorized_signatory);
            let authorized_signatory = '';
            if (data.authorized_signatory == 1) {
                authorized_signatory = 'E. Hoefsmit';
            } else if (data.authorized_signatory == 2) {
                authorized_signatory = 'J. van de Beek';
            }

            let notice_period = '';
            if (data.notice_period == 1) {
                notice_period = 'één kalendermaand';
            } else {
                notice_period = '30 dagen';
            }

            const isForty = data?.length_weeks == 40;
            const isAdv = !!data?.adv;
            let adv = '';
            if (isAdv && isForty) {
                adv = 'Uurloon = bruto maandsalaris / 164,66 o.b.v. 40 uur per week (inclusief 2 uur opbouw ADV).';
            } else if (!isAdv && isForty) {
                adv = 'Uurloon = bruto maandsalaris / 173,33 o.b.v. 40 uur per week.';
            } else if (!isAdv && !isForty) {
                adv = 'Uurloon = bruto maandsalaris / 164,66 o.b.v. 38 uur per week.';
            }

            setFormatted({
                authorized_signatory,
                adv,
                notice_period
            });

            setTimeout(() => {
                document.body.classList.add('ready');
            }, 250);
        });
    }, []);

    if (!data?.company_name) {
        return <h1>Loading...</h1>; 
    }

    return <>
        <div className="frontpage">
            <h1>Maak kennis <br /> met Growing People</h1>
            <p>
                Bedankt voor jullie interesse in een<br/>
                samenwerking met ons bedrijf. We leggen<br/>
                jullie graag uit wie wij zijn en hoe wij werken.
            </p>
            <div style={{fontStyle: 'italic'}}>www.growing-people.nl</div>
            <img className="frontpage__img1" src={logo1} />
            <img className="frontpage__img2" src={logo2} />
        </div>

        <div className="page">
            <h2 className="page__title">Wie wij zijn</h2>
            <p className="page__content">
                <strong>Growing People</strong> is een innovatief bedrijf dat gespecialiseerd is in technische detachering. Onze missie? Het laten groeien van talenten én bedrijven. Dit doen we door op een zorgvuldige en efficiënte manier de juiste organisaties aan de juiste talenten te koppelen. We kijken naar het toekomstige dienstverband van een talent en werken veel samen met bedrijven die vacatures structureel of voor een langere tijd willen invullen.
            </p>
            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>2</small>
            </div>
        </div>

        <div className="page">
            <h2 className="page__title">Onze diensten</h2>
            <p className="page__content">
                Wij vertellen jullie graag meer over wat wij als bedrijf voor jullie kunnen betekenen en hoe we jullie als organisatie kunnen ontzorgen. 
            </p>
            <div className="solution">
                <div className="solution__item">
                    <div className="solution__item-index">1.</div>
                    <div className="solution__item-text">Detachering</div>
                </div>
                <div className="solution__divider"></div>
                <div className="solution__item">
                    <div className="solution__item-index">2.</div>
                    <div className="solution__item-text">Projectopdrachten</div>
                </div>
                <div className="solution__divider"></div>
                <div className="solution__item">
                    <div className="solution__item-index">3.</div>
                    <div className="solution__item-text">Noodoplossing</div>
                </div>
            </div>
            <div className="page__footerSkew">
                <div className="page__footerSkew-bg"></div>
                <img className="page__footerSkew-img" src={logo3} />
            </div>
        </div>

        <div className="page pageBackground">
            <h2 className="page__title">1. Detachering</h2>
            <p className="page__content">
                Wij gaan op zoek naar een passende medewerker voor de bij jullie openstaande vacatures. Dit doen we aan de hand van een strenge selectieprocedure. Onze accountmanagers en recruiters kennen de weg op het internet en hebben een groot netwerk van technische professionals. Daardoor kunnen ze binnen een niet al te lange tijd een aantal potentiële kandidaten aandragen waarvan zij denken dat deze bij jullie organisatie passen. 
            </p>
            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>4</small>
            </div>
            <img className="page__footerLogo" src={logo4} />
        </div>

        <div className="page">
            <p className="page__text">
                Deze selectieprocedure bespaart jullie bedrijf niet alleen tijd, maar is ook geheel kosteloos. Jullie hebben de gelegenheid zelf te bepalen of jullie de kandidaat interessant vinden en het detacheringstraject dan ook te starten.
                <br/>
                De kandidaat komt eerst bij ons op de loonlijst te staan. Wij dragen dan ook de verantwoordelijkheid voor de werkgeversrisico’s. Het detacheringstraject duurt minimaal { data.length_months } maand{data.length_months > 1 ? 'en' : ''} met een minimum van { data.length_hours } normaal gewerkte uren. Indien hieraan is voldaan, kunnen jullie kiezen uit de volgende opties:
            </p>

            <div className="page__blockquotes">
                <div className="page__blockquotes-item">
                    Jullie zijn tevreden met de kandidaat, willen hem zelf nog geen arbeidscontract aanbieden en verlengen de opdrachtovereenkomst via ons;
                </div>
                 <div className="page__blockquotes-item">
                    Jullie doen de kandidaat een aanbod om hem zelf in dienst te nemen, nadat hij het aantal uur conform de opdrachtovereenkomst heeft gewerkt; 
                </div>
                 <div className="page__blockquotes-item">
                    Jullie besluiten dat de kandidaat stopt bij jullie organisatie en zeggen de opdrachtovereenkomst op.
                </div>
            </div>

            <small style={{
                position: 'absolute',
                top: 0,
                right: '25px',
                fontStyle: 'italic'
            }}>
                Onze voorwaarden
            </small>

            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>5</small>
            </div>
        </div>

        <div className="page">
            <p className="page__text">
                <strong>Het uurtarief berekenen</strong><br/>
                Gedurende het detacheringstraject worden de wekelijks gewerkte uren van de medewerker in rekening gebracht voor een afgesproken uurtarief. Dit tarief wordt als volgt berekend:
                <br/>
                { formatted['adv'] } 
                <br/>
                Uurloon x { data.margin_factor } = het uurtarief voor normaal gewerkte uren, exclusief btw en overige vergoedingen. Indien het uurloon van de medewerker omhoog of omlaag gaat (bijv. door cao-wijzigingen), dan wordt het uurloon naar rato aangepast.
                De medewerker wordt fulltime bij jullie ingezet. Het aantal werkuren per week is dus { data.length_weeks }, tenzij dit anders is afgesproken. Wij betalen de kandidaat door bij ziekte en tijdens feestdagen en/of afgesproken vrije dagen.
            </p>

            <div className="page__hourlyRate">
                <h3>Samenvattend, wat zit er bij het uurtarief inbegrepen?</h3>
                <ul>
                    <li>Het salaris van de medewerker;</li>
                    <li>Werknemers- en werkgeverslasten;</li>
                    <li>25 vakantiedagen;</li>
                    <li>Het aantal ADV-dagen volgens de cao van jullie bedrijf;</li>
                    <li>8% vakantiegeld;</li>
                    <li>De kort verzuimregeling;</li>
                    <li>Pensioenvoorziening;</li>
                    <li>Doorbetaling bij erkende feestdagen;</li>
                    <li>Doorbetaling bij ziekte;</li>
                    <li>Bruto bureaumarge;</li>
                </ul>
                <div className="page__hourlyRate-bg"></div>
                <img className="page__hourlyRate-img" src={logo5} />
            </div>

            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>6</small>
            </div>
        </div>

        <div className="page">
            <p className="page__text">
                <strong>Wat zit er niet bij het uurtarief inbegrepen?</strong><br/>
                Eventuele kosten die buiten het uurtarief vallen worden met jullie overlegd. Voorbeelden van deze kosten kunnen zijn, maar beperken zich niet tot:
                Reiskosten; De inzet van een eventuele bedrijfsauto; Een tankpas; Onkostenvergoeding(en); Toeslagen en/of overuren; PBM’s; Studiekosten; Gereedschap; btw; Eventuele verhogingen van het salaris vanuit de geldende cao; Overige vergoedingen vanuit de geldende cao.
            </p>

            <div className="page__terms">
                <h1 className="page__terms-title">Andere voorwaarden</h1>
                <ul>
                    <li>Zodra het detacheringstraject start, geldt er een proeftijd van een maand. Deze geldt voor alle drie de partijen;</li>
                    <li>Wij hanteren op al onze verkoopfacturen een betalingstermijn van { data.payment_term } dagen;</li>
                    <li>De opdrachtovereenkomst kan tussentijds en door beide partijen middels een aangetekend schrijven beëindigd worden, met inachtneming van één kalendermaand opzegtermijn.</li>
                </ul>
            </div>

            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>7</small>
            </div>
        </div>

        <div className="page pageBackground">
            <h2 className="page__title">2. Projectopdracht</h2>
            <p className="page__content">
                Wanneer jullie voor een project ervaren krachten zoeken, kunnen jullie ook op ons rekenen. We hebben specialisten uit verschillende vakgebieden in vaste dienst die op projectbasis opdrachten uitvoeren.
                <br/><br/>
                Samen met de accountmanager overleggen jullie over de inhoud van het project, wat de geschatte start- en einddatum is en wat voor specialisten jullie nodig hebben. Vervolgens maakt de accountmanager een voorstel en legt deze aan jullie voor. Hij controleert wanneer de voor jullie geschikte krachten beschikbaar zijn en houdt rekening met jullie planning.
                <br/><br/>
                De specialisten worden ingezet voor de overeengekomen periode. Wij nemen alleen projecten aan voor minstens { data.project_months } maand{ data.project_months > 1 ? 'en' : ''}. Bij een projectopdracht hanteren we een vooraf overeengekomen uurtarief. De hoogte is afhankelijk van de duur van de opdracht en de complexiteit van de werkzaamheden. Wanneer we een opdracht van jullie aannemen, is het niet mogelijk de kandidaat zelf in dienst te nemen.
            </p>
            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>8</small>
            </div>
            <img className="page__footerLogo" src={logo4} />
        </div>

        <div className="page pageBackground">
            <h2 className="page__title">3. Noodoplossing</h2>
            <p className="page__content">
                Zijn jullie dringend op zoek naar een medewerker, dan kunnen we als noodoplossing binnen een korte tijd een professional inzetten. In de tussentijd zoeken we naar een kandidaat die voor de lange termijn bij jullie aan de slag gaat. Hoe dit traject er precies uitziet, zetten we hieronder voor jullie op een rijtje:
            </p>
            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>9</small>
            </div>
            <img className="page__footerLogo" src={logo4} />
        </div>
        <div className="page">
            <div className="phases">
                <div className="phases-item">
                    <div className="phases-item--conn"></div>
                    <div className="phases-item--text">
                        <strong>Fase 1:</strong> Jullie organisatie zoekt een kandidaat voor een belangrijke en/of moeilijk invulbare positie;
                    </div>
                </div>
                <div className="phases-item">
                    <div className="phases-item--conn"></div>
                    <div className="phases-item--text">
                        <strong>Fase 2:</strong> Wij zoeken een specialist die op de korte termijn beschikbaar is en ruime ervaring heeft in de functie die vervuld moet worden;
                    </div>
                </div>
                <div className="phases-item">
                    <div className="phases-item--conn"></div>
                    <div className="phases-item--text">
                        <strong>Fase 3:</strong> Wij zetten tijdelijk een specialist in die aan de slag gaat in de openstaande functie;

                    </div>
                </div>
                <div className="phases-item">
                    <div className="phases-item--conn"></div>
                    <div className="phases-item--text">
                        <strong>Fase 4:</strong> Terwijl de specialist de functie vervult, zoeken wij een kandidaat die voor op de lange termijn bij jullie aan de slag gaat;

                    </div>
                </div>
                <div className="phases-item">
                    <div className="phases-item--conn"></div>
                    <div className="phases-item--text">
                        <strong>Fase 5:</strong> Zodra we iemand voor de lange termijn vinden en deze persoon bij jullie bedrijf begint, stopt de specialist en start het reguliere detacheringstraject voor de nieuwe medewerker.
                    </div>
                </div>
            </div>

            <div className="phases-text">
                De duur van het traject hangt af van de functie die vervuld moet worden. Onze accountmanagers geven per traject altijd een indicatie van de verwachte duur.
            </div>

            <small style={{
                position: 'absolute',
                top: 0,
                right: '25px',
                fontStyle: 'italic'
            }}>
                Onze voorwaarden
            </small>

            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>10</small>
            </div>
        </div>

        <div className="page">
            <h2 className="page__title">Evalueren en analyseren</h2>
            <div className="page__content bigTitle">
                <p style={{marginBottom: 0}}>
                    Bij Growing People vinden we het belangrijk dat we blijven monitoren hoe de huidige werksituatie van de medewerker is. Zijn jullie tevreden met de medewerker en is deze tevreden met jullie? Deze vragen worden beantwoord in de zogenoemde evaluatierondes die op de volgende momenten tijdens het detacheringstraject plaatsvinden:
                </p>
                <ul style={{
                        listStyle: 'square',
                        marginTop: 0,
                        paddingLeft: '20px'
                    }}>
                    <li>Vlak voor het einde van de proeftijd;</li>
                    <li>Halverwege het traject;</li>
                    <li>Twee maanden voor het einde van het detacheringstraject.</li>
                </ul>
                <p>
                    Growing People zoekt tijdens deze contactmomenten altijd naar mogelijkheden om de relatie tussen jullie en de medewerker nóg sterker te maken.
                </p>
            </div>
            <div className="page__footer">
                <small>www.growing-people.nl</small>
                <small>11</small>
            </div>
        </div>

        <div className="page">
            <div className="sign__bg">
                <div className="sign__bg-color"></div>
                <img className="sign__bg-img one" src={logo5} />
                <img className="sign__bg-img two" src={logo5} />
                <img className="sign__bg-img three" src={logo5} />
            </div>

            <div className="sign">
                <p className="sign__text">
                    Met het ondertekenen van dit document gaan we ervan uit dat jullie onze voorwaarden begrijpen en bij een eventuele samenwerking hiermee akkoord gaan. 
                </p>
                <div className="sign__question">
                    Hebben jullie nog vragen? Neem vooral contact met ons op!<br/>
                    T: <a href="" className="sign__question-link">076 - 203 19 36</a><br/>
                    M: <a href="" className="sign__question-link">breda@growing-people.nl</a>
                </div>

                <div className="sign__field">
                    <div className="sign__field-item">
                        <strong>Growing People B.V.</strong><br/>
                        Naam: { formatted?.authorized_signatory }<br/>
                        Datum:<br/>
                        <br/>
                        Handtekening:<br/><br/><br/><br/>
                        <div style={{borderBottom: '1px solid rgba(0, 0, 0, .4)', width: '150px'}}></div>
                    </div>
                    <div className="sign__field-item">
                        <strong>{ data.company_name }</strong><br/>
                        Naam: { data.authorized_signatory_client }<br/>
                        Datum:<br/>
                        <br/>
                        Handtekening:<br/><br/><br/><br/>
                        <div style={{borderBottom: '1px solid rgba(0, 0, 0, .4)', width: '150px'}}></div>
                    </div>
                </div>
            </div>

            <div className="page__footer">
                <img src={logo} height="30" alt=""/>
                
                <small>12</small>
            </div>
        </div>
    </>;
}

export default CooperationConditionDocument;